var global = require('../internals/global');
var isCallable = require('../internals/is-callable');

var String = global.String;
var TypeError = global.TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/a-possible-prototype.js
// module id = 161
// module chunks = 0